import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pullFromCache, saveToCache } from '../Loaders/uploadsCache';
import { addUpload } from '../Redux/store';

/**
 * Hook to persist uploads to localStorage
 * Loads from cache on mount, saves to cache when uploads change
 */
export default function useUploadsPersistence() {
  const dispatch = useDispatch();
  const uploads = useSelector((s) => s.uploads.byId);

  // Load from cache on mount
  useEffect(() => {
    const cachedUploads = pullFromCache();
    if (cachedUploads) {
      Object.values(cachedUploads).forEach(upload => {
        dispatch(addUpload(upload));
      });
    }
  }, [dispatch]);

  // Save to cache when uploads change
  useEffect(() => {
    if (Object.keys(uploads).length > 0) {
      saveToCache(uploads);
    }
  }, [uploads]);
}
